import {
  createFrontendPlugin,
  PageBlueprint,
  PluginHeaderActionBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiNodeTree } from '@remixicon/react';
import { rootRouteRef } from './routes';

export const page = PageBlueprint.make({
  params: {
    title: 'Integration Architecture - Decision Matrix',
    icon: <RiNodeTree />,
    path: '/decision-matrix',
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/comparison-app').then(m => <m.ComparisonApp />),
  },
});

export const headerActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () =>
        import('./components/comparison-app/header-actions').then(m => (
          <m.HeaderActions />
        )),
    }),
});

export const decisionMatrixPlugin = createFrontendPlugin({
  pluginId: 'decision-matrix',
  extensions: [page, headerActions],
  routes: {
    root: rootRouteRef,
  },
});
